// Phone / email helpers for the contact buttons. The devotee record keeps these as
// comma-separated strings (Devotee.mobilesAsString / emailsAsString) — the first value is used.

/** First value of a comma/semicolon separated list. */
function first(value?: string | null): string | null {
  const v = (value ?? "").split(/[,;]/)[0]?.trim();
  return v || null;
}

/** "+91 98200 10234" → "+919820010234" (kept with its country code for tel:). */
export function telNumber(mobile?: string | null): string | null {
  const raw = first(mobile);
  if (!raw) return null;
  const plus = raw.trim().startsWith("+");
  const digits = raw.replace(/\D/g, "");
  if (digits.length < 7) return null;
  return (plus ? "+" : "") + digits;
}

/**
 * wa.me needs digits with a country code and no "+". A bare 10-digit number is assumed Indian
 * (+91) — that is the only country code in use here.
 */
export function whatsappNumber(mobile?: string | null): string | null {
  const tel = telNumber(mobile);
  if (!tel) return null;
  const digits = tel.replace(/\D/g, "");
  if (digits.length === 10) return `91${digits}`;
  return digits.length >= 11 ? digits : null;
}

export function emailAddress(email?: string | null): string | null {
  const v = first(email);
  return v && v.includes("@") ? v : null;
}
